import { useQuery } from '@tanstack/react-query';
import { StatusCode, REACT_QUERY_KEYS } from '@hungryroot/rest';
import {
  getCustomer,
  CustomerIncludes,
  type CustomerV1,
  type CustomerIncludesAll,
} from '@hungryroot/rest/api/get_customer/get/get-customer';

// Plan credits will be null when customer is in canceled state
// If customer is on hold, on_hold_until_date will return a date string reflecting the next delivery date
export type { CustomerV1 as Customer, CustomerIncludesAll };
export { CustomerIncludes };

const TIME_LIMIT_15_MINUTES = 15 * 60 * 1000;

async function getCustomerIncludesAll() {
  return await getCustomer({
    includes: [CustomerIncludes.All],
  });
}

export function useCustomer(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [REACT_QUERY_KEYS.CUSTOMERS, { includes: CustomerIncludes.All }],
    queryFn: async () => {
      const resp = await getCustomerIncludesAll();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: TIME_LIMIT_15_MINUTES,
    staleTime: TIME_LIMIT_15_MINUTES,
  });
}
